// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Models
import { FahrzeugModell } from "#/common/models/model_selection/FahrzeugModell";

@Component({
  mixins: [template],
  components: {},
})
export class ModelSelectionModuleItem extends Vue {
  @Prop()
  public title!: string;

  @Prop({ type: [Object] })
  public fahrzeugModell!: FahrzeugModell;

  private alreadyAnimated: boolean = false;

  private animationDone: boolean = false;

  private animation = "modelSelectionfadeInUp";

  get animationClassList() {
    if (this.alreadyAnimated && !this.animationDone) {
      return ["animated", this.animation];
    } else {
      return [];
    }
  }

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll(null);
    (this.$el as HTMLElement).addEventListener("animationend", () => {
      this.animationDone = true;
    });
  }

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    if (this.animation && !this.alreadyAnimated) {
      if (
        window.innerHeight + this.getWindowScrollTop() >
        this.offsetTop(this.$el)
      ) {
        this.alreadyAnimated = true;
      }
    }
  }

  getWindowScrollTop() {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";

    return supportPageOffset
      ? window.pageYOffset
      : isCSS1Compat
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
  }

  offsetTop(el: Element) {
    let rect = el.getBoundingClientRect();
    return rect.top + document.body.scrollTop;
  }

  handleClick(event) {
    event.preventDefault();
    this.$emit("click", event);
  }
}
